<script lang="ts" setup>
import { TriangleAlert } from 'lucide-vue-next'
import { ErrorMessage } from 'vee-validate'
import { toValue } from 'vue'
import { useFormField } from './useFormField'

const { name, formMessageId } = useFormField()
</script>

<template>
  <ErrorMessage
    :id="formMessageId"
    v-slot="{ message }"
    as="p"
    :name="toValue(name)"
    class="text-sm font-medium text-destructive"
  >
    <TriangleAlert class="h-3 w-3 inline-block mr-1 mb-1" />
    <span>{{ message }}</span>
  </ErrorMessage>
</template>
